/* eslint-disable eqeqeq */
/* eslint-disable react/require-default-props */
import React, {
    useCallback, useEffect, useMemo, useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import Icon, { ICON_TYPE_CLOSE_SLIM } from 'ui-library/components/Icon';
import { Modal, RadioButtonGroup, Select } from '../../ui-library';
import { ContactGroup, ContactGroupEnum } from '../Connections/types';

import './ThreeBGroupsModal.css';

type ThreeBGroupsModalProps = {
    title?: string;
    subtitle?: string;
    show: string | undefined;
    onClose: () => void;
    onSelect: (groupId: string, isJointAccount: boolean) => void;
    onChangeMainClient?: (clientId) => void
    groups: Array<ContactGroup>;
    clientId?: number;
}

export const ThreeBGroupsModal = ({
    title = undefined,
    subtitle = undefined,
    show,
    onClose,
    groups,
    onSelect,
    clientId,
    onChangeMainClient,
}: ThreeBGroupsModalProps) => {
    const { t } = useTranslation();
    const [selectedGroup, setSelectedGroup] = useState<string>('');
    const [error, setError] = useState(null);
    const selectedGroupItem = useMemo(() => groups.find(f => f.groupId === parseInt(selectedGroup, 10)), [selectedGroup]);

    const closeModal = useCallback(() => {
        onClose();
    }, [onClose]);

    useEffect(() => {
        if (selectedGroup) {
            setError(null);
        }
    }, [selectedGroup]);

    const onSelectedGroup = useCallback(() => {
        if (!selectedGroup) {
            setError(t('threeBGroupsModal.requiredField'));

            return;
        }

        setError(null);
        onSelect(selectedGroup, selectedGroupItem?.groupName === ContactGroupEnum.ja);
    }, [onSelect, selectedGroup, t, selectedGroupItem]);

    const groupItems = useMemo(() => [{
        value: '',
        label: t('position.pleaseSelect'),
    // eslint-disable-next-line no-unsafe-optional-chaining
    }, ...(groups.filter((group: ContactGroup) => (show === 'mortgage' ? ([ContactGroupEnum.mortgage, ContactGroupEnum.ja]?.includes(group?.groupName)) : group?.groupName !== ContactGroupEnum.mortgage))?.map(i => ({
        label: `${![ContactGroupEnum.threeB, ContactGroupEnum.mortgage]?.includes(i.groupName) ? `${t(`connections.groupName.${i.groupName.toLowerCase()}`)} | ` : ''}${Object.values(i.owners)
            .join(', ')}`,
        value: i.groupId,
        desc: i.groupName === ContactGroupEnum.mortgage ? '1_Mortgage' : i.groupName,
    }))
        .sort((a, b) => {
            if (a.desc < b.desc) return -1;
            if (a.desc > b.desc) return 1;

            return 0;
        }))], [groups]);

    const joinAccountOwners = useMemo(() => Object?.keys(selectedGroupItem?.owners || {})
        ?.map(key => ({
            label: selectedGroupItem?.owners?.[key],
            value: key,
        })), [selectedGroupItem?.owners]);

    const handleSelectMainClient = useCallback((e) => {
        onChangeMainClient?.(e.target.value);
    }, [onChangeMainClient]);

    const closeIcon = useMemo(() => (<Icon type={ICON_TYPE_CLOSE_SLIM} size={20} />), []);

    return (
        <Modal
            className="three-b-groups-modal"
            visible={!!show}
            onCancel={closeModal}
            title={title ?? t(show === 'mortgage' ? 'mortgageModal.title' : 'threeBGroupsModal.title')}
            onOk={onSelectedGroup}
            okText={t('confirmation.continue')}
            okButtonProps={{ type: 'primary', disabled: !selectedGroup }}
            width={515}
            keyboard={false}
            maskClosable={false}
            closable
            borderRadius
            closeIcon={closeIcon}
        >
            <Select
                options={groupItems}
                label=""
                value={selectedGroup}
                onChange={setSelectedGroup}
                error={error}
            />
            {clientId && Object?.keys(selectedGroupItem?.owners || {})?.length > 1 && show !== 'mortgage' && (
                <div className="select-main-client">
                    {subtitle && (
                        <p>
                            {subtitle}
                            :
                        </p>
                    )}
                    {subtitle == undefined
                        && (
                            <p>
                                {t('productOffer.3bGroup.defineMainClient.title')}
                                :
                            </p>
                        )}
                    <RadioButtonGroup
                        horizontal
                        options={joinAccountOwners}
                        onChange={handleSelectMainClient}
                        error=""
                        value={`${clientId}`}
                    />
                </div>
            )}
        </Modal>
    );
};
